/**
 * HeaderAnchor
 * ======================================
 * - Close mobile menu when anchor link is clicked
 */

class HeaderAnchor {
  constructor() {
    this.navs = document.querySelectorAll('.header-nav')

    if (!this.navs.length) {
      return
    }

    this.init()
  }

  init() {
    this.navs.forEach(nav => {
      nav.querySelectorAll('a[href*="#"]').forEach(link => {
        link.addEventListener('click', () => {
          this.closeMenu()
        })
      })
    })
  }

  closeMenu() {
    document.body.classList.remove('nav-is-open')
  }
}

new HeaderAnchor()
